import { CommonTabbarState, TabRoute } from '@/global/components/common-tabbar';
import './index.less';
import { useEffect, useState, useRef, useContext } from 'react';
import { TAB_TYPE } from '@/enums/tab-type';
import { CommonTabbarContext } from '@/App';
import { useParams } from 'react-router-dom';
import { InputNumber, Select, Skeleton, Table } from 'antd';
import { getMonitorParametersByProjectId, updateMonitorParameter } from '@/api/monitor-object/monitor-parameter';
import { MonitorParameter } from '@/global/interface/monitor-object/monitor-parameter';
import TnMessage from '@/global/components/message';
import { DRAW_MAIN_KEY } from '..';
import { Transfer2BackEndScale, Transfer2DisplayScale } from '@/global/utils/unit-type';


interface IProps {

}

export default function MonitorThresholdPanel(props: IProps) {
    const { projectId } = useParams();
    const commonTabbarContext = useContext<CommonTabbarState>(CommonTabbarContext); // tabbar上下文
    const [tableList, setTableList] = useState<MonitorParameter[]>([]); // 表格数据
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {


        setLoading(true);
        getMonitorParametersByProjectId(+projectId).then(res => {
            if (res.status === 200) {
                let data: MonitorParameter[] = res.data || [];
                //构造数据
                let list: MonitorParameter[] = [];
                data?.forEach((item: MonitorParameter) => {
                    if (item?.unit) {
                        let scale = Transfer2DisplayScale(item?.unit);
                        if (item?.t2) {
                            item.t2Dis = item?.t2 * scale;
                        }
                        if (item?.t3) {
                            item.t3Dis = item?.t3 * scale;
                        } else {

                        }
                        if (item?.t4) {
                            item.t4Dis = item?.t4 * scale;
                        } else {

                        }
                    }
                    list.push(item);

                    // item?.subParametersDq?.forEach((sub: MonitorParameter) => {
                    //     if (item?.unit) {
                    //         let scale = Transfer2DisplayScale(item?.unit);
                    //         if (item?.t2) {
                    //             item.t2Dis = item?.t2 * scale;
                    //         }
                    //         if (item?.t3) {
                    //             item.t3Dis = item?.t3 * scale;
                    //         }
                    //         if (item?.t4) {
                    //             item.t4Dis = item?.t4 * scale;
                    //         }
                    //     }
                    //     list.push(sub);
                    // })
                })
                setTableList(list);

                // 新增页签
                let addTab: TabRoute = {
                    title: '预警值',
                    url: `${TAB_TYPE.MONITOR_THRESHOLD}`,
                    closable: true
                }
                commonTabbarContext.pushRoute(addTab);
            }
        }).catch(err => {
            TnMessage.error("获取数据失败");
            commonTabbarContext.navigate(`${TAB_TYPE.DRAW}/${DRAW_MAIN_KEY}`)
        }).finally(() => {
            setLoading(false);
        })
    }, [])

    const onValueChange = (value: number, mp: MonitorParameter, field: string) => {
        if (!mp) return;
        let idx = tableList?.findIndex(item => item.id === mp.id);
        mp[field] = value;
        tableList[idx] = mp;
        setTableList([...tableList]);
    }

    const onValueBlur = (mp: MonitorParameter, fieldDis: string, field: string) => {
        if (!mp || !mp?.unit) return;
        let idx = tableList?.findIndex(item => item.id === mp.id);

        let scale = Transfer2BackEndScale(mp?.unit);
        let backEndValue = scale * parseFloat(mp[fieldDis]);

        let par = {};
        if (field === 't2') {
            par = { t2: backEndValue };
        } else if (field === 't3') {
            par = { t3: backEndValue };
        } else if (field === 't4') {
            par = { t4: backEndValue };
        }
        updateMonitorParameter(mp.id, par).then(res => {
            mp[field] = backEndValue;
            tableList[idx] = mp;
            setTableList([...tableList]);
            TnMessage.success("更新成功");
        }).catch(err => {
            TnMessage.error("更新失败");
        })
    }


    return (
        <div className='monitor-threshold-container'>
            <Skeleton loading={loading} active>
                <div className="monitor-threshold-table">
                    <div className="head-row">
                        <div className="head-cell flex-1">监测参数编号</div>
                        <div className="head-cell flex-1">监测参数名称</div>
                        <div className="head-cell flex-1">监测参数代号</div>
                        <div className="head-cell flex-1">单位</div>
                        <div className="head-cell flex-1">设置二级预警值</div>
                        <div className="head-cell flex-1">设置三级预警值</div>
                        <div className="head-cell flex-1">设置四级预警值</div>
                    </div>
                    {tableList?.map((item: MonitorParameter, key) => (
                        <div className="body-row">
                            <div className="body-cell flex-1">{item?.encoding || ''}</div>
                            <div className="body-cell flex-1">{item?.name || ''}</div>
                            <div className="body-cell flex-1">{item?.code || ''}</div>
                            <div className="body-cell flex-1">{item?.unit || ''}</div>
                            <div className="body-cell flex-1">
                                {item?.unit && <InputNumber
                                    style={{ width: '100%' }}
                                    size='small'
                                    controls={false}
                                    suffix={item?.unit}
                                    value={item?.t2Dis}
                                    onChange={(e) => onValueChange(e, item, 't2Dis')}
                                    onBlur={(e) => onValueBlur(item, 't2Dis', 't2')}
                                />}
                            </div>
                            <div className="body-cell flex-1">
                                {item?.unit && <InputNumber
                                    style={{ width: '100%' }}
                                    size='small'
                                    controls={false}
                                    suffix={item?.unit}
                                    value={item?.t3Dis}
                                    onChange={(e) => onValueChange(e, item, 't3Dis')}
                                    onBlur={(e) => onValueBlur(item, 't3Dis', 't3')}
                                />}
                            </div>
                            <div className="body-cell flex-1">
                                {item?.unit && <InputNumber
                                    style={{ width: '100%' }}
                                    size='small'
                                    controls={false}
                                    suffix={item?.unit}
                                    value={item?.t4Dis}
                                    onChange={(e) => onValueChange(e, item, 't4Dis')}
                                    onBlur={(e) => onValueBlur(item, 't4Dis', 't4')}
                                />}
                            </div>
                        </div>
                    ))}
                </div>
            </Skeleton>
        </div>
    )
}